export enum IAMTenant {
  PLATFORM = 'PLATFORM',
  MARKANT_CENTRAL = 'MARKANT_CENTRAL',
}
